var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column justify-content-center items-center"},[_c('qrcode-vue',{attrs:{"value":_vm.value,"size":_vm.size,"level":_vm.level}}),_c('div',{class:_vm.fontClasses},[_vm._v(_vm._s(_vm.code))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }